module.exports = __webpack_public_path__ + "images/icons/icon-hourglass-888a398e.svg";